import { Award, Layers, Headset, Wrench } from "lucide-react";

const INDICATORS = [
    { icon: Award, value: "+30", label: "Anos de indústria" },
    { icon: Layers, value: "100%", label: "Produção integrada" },
    { icon: Headset, value: "Técnico", label: "Suporte especializado" },
    { icon: Wrench, value: "Sob", label: "Medida / projeto" },
];

export const Authority = () => {
    return (
        <section
            id="autoridade"
            data-testid="authority-section"
            className="bg-white section-pad"
        >
            <div className="container-buzas grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
                <div className="relative order-2 lg:order-1">
                    <div className="relative rounded-sm overflow-hidden border border-buzas-gray-200 shadow-lg">
                        <img
                            src="/images/02.png"
                            alt="Soldagem industrial em estrutura metálica"
                            className="w-full h-[440px] md:h-[520px] object-cover"
                            loading="lazy"
                        />
                    </div>
                    <div className="hidden md:block absolute -bottom-6 -right-6 bg-buzas-navy text-white p-6 rounded-sm shadow-xl max-w-[260px]">
                        <p className="text-[11px] font-bold tracking-[0.2em] uppercase text-white/70">
                            Indústria metalúrgica
                        </p>
                        <p className="mt-2 text-lg font-bold leading-snug">
                            Peças e estruturas para alta exigência.
                        </p>
                    </div>
                </div>

                <div className="order-1 lg:order-2">
                    <span className="eyebrow text-buzas-red">
                        Autoridade técnica
                    </span>
                    <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold text-buzas-navy leading-tight">
                        +30 anos de indústria metalúrgica aplicados ao agro.
                    </h2>
                    <p className="mt-5 text-base md:text-lg text-buzas-navy/75 leading-relaxed">
                        A Buzas atua há mais de 30 anos na indústria
                        metalúrgica, desenvolvendo peças e estruturas para
                        setores que exigem resistência e desempenho contínuo.
                    </p>
                    <p className="mt-3 text-base text-buzas-navy/65 leading-relaxed">
                        Nossa produção integrada reduz falhas, melhora a
                        durabilidade das peças e garante padrão consistente de
                        qualidade.
                    </p>

                    <div className="mt-10 grid grid-cols-2 gap-4 md:gap-5">
                        {INDICATORS.map(({ icon: Icon, value, label }, i) => (
                            <div
                                key={label}
                                data-testid={`indicator-${i}`}
                                className="flex items-start gap-3 rounded-sm border border-buzas-gray-200 bg-buzas-gray p-5"
                            >
                                <div className="inline-flex h-10 w-10 items-center justify-center rounded-sm bg-white text-buzas-navy">
                                    <Icon className="h-5 w-5" strokeWidth={1.75} />
                                </div>
                                <div>
                                    <p className="text-xl md:text-2xl font-bold text-buzas-navy leading-none">
                                        {value}
                                    </p>
                                    <p className="mt-1.5 text-xs font-semibold text-buzas-gray-500 uppercase tracking-wider">
                                        {label}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
